import {combineReducers} from 'redux';
import PesquisaReducer  from './PesquisaReducer'

export default combineReducers(
    {PesquisaReducer}
)
